import { FunctionComponent, memo, useContext } from "react";
import { EllipsisMenu, EllipsisMenuItem } from "@edgetier/client-components";
import { IProps } from "./tags-actions-menu.types";
import { InteractionContext } from "components-for/interactions/interaction-context/interaction-context";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import "./tags-actions-menu.scss";

/**
 * An options menu to add tag groups
 */
const TagsActionsMenu: FunctionComponent<IProps> = () => {
    const { isAddTagGroupSelectVisible, setIsAddTagGroupSelectVisible } = useContext(InteractionContext);

    return (
        <div className="tags-actions-menu">
            <EllipsisMenu placement="bottom-end" overflowContainer>
                <EllipsisMenuItem
                    isDisabled={isAddTagGroupSelectVisible}
                    icon={faPlus}
                    onClick={() => {
                        setIsAddTagGroupSelectVisible(true);
                    }}
                >
                    Add tag group
                </EllipsisMenuItem>
            </EllipsisMenu>
        </div>
    );
};

export default memo(TagsActionsMenu);
